module.exports = __webpack_public_path__ + "img/id-card.e7fecd2a.png";